import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Row, Col, Label } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import Layout from "../../components/Wrappers/Layout";
import val from "../../getThemeDetails";
import constants from "../../config/constants";
import { useEffect,useState } from "react";
import { resetAdminKycMappingList } from "../../redux/actions/adminKycMappingListAction";



function AdminKycManagement() {
	const { t } = useTranslation();

	const history = useHistory();
	const { pathname } = useLocation();
	const dispatch = useDispatch();
	const Theme = useSelector((state) => state.theme.theme);
	// const partnerId = getMappedListForAdminRes?.data?.partnerId;
	const {
		data: { isMyBankAllowed, isMyWalletAllowed, isMyCardAllowed }
	} = useSelector(({ walletSetting }) => walletSetting);

	const getMappedListForAdminRes = useSelector(
		({ getMappedListsForadmins }) => getMappedListsForadmins
	)
    const [allowedSubModules, setAllowedSubModules] = useState([]);
	const partnerloginUser = useSelector(({ login }) => login);
	var authTokens = partnerloginUser.data.AuthToken;
	sessionStorage.setItem("walletOwnerId", partnerloginUser.data.partnerId);

	const login = useSelector(({ login }) => login);

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	const options = [
		{
			id: 1,
			label: "Create Proof Type",
			// route: "/index/risk-rules",merchantInvoice
			route: "/index/CreateProofType",
			// route: "/index/merchant-invoice",
			src: `${process.env.PUBLIC_URL}/${Theme}/CREATE PROOF TYPE.png`,
			flag: "CREATE PROOF TYPE"
		},
		{
			id: 2,
			label: "Create Document Type",
			// route: "/index/risk-rules",merchantInvoice
			route: "/index/CreateDocumentType",
			// route: "/index/merchant-invoice",
			src: `${process.env.PUBLIC_URL}/${Theme}/CREATE DOCUMENT TYPE.png`,
			flag: "CREATE DOCUMENT TYPE"
		},
		{
			id: 3,
			label: "KYC Mapping",
			// route: "/index/risk-rules",merchantInvoice
			route: "/index/KycMapping",
			// route: "/index/merchant-invoice",
			src: `${process.env.PUBLIC_URL}/${Theme}/kyc configration.png`,
			flag: "KYC MAPPING"
		},
		{
			id: 4,
			label: "KYC Report",
			// route: "/index/risk-rules",merchantInvoice
			route: "/index/KycReport",
			// route: "/index/merchant-invoice",
			src: `${process.env.PUBLIC_URL}/${Theme}/kyc report.png`,
			flag: "KYC REPORT"
		},
		{
			id: 5,
			label: "KYB Report",
			// route: "/index/risk-rules",merchantInvoice
			route: "/index/KybReport",
			// route: "/index/merchant-invoice",
			src: `${process.env.PUBLIC_URL}/${Theme}/kyb report.png`,
			flag: "KYB REPORT",
		}
		// {
		//   id: 4,
		//   label: "My Wallets",
		//   route: "/index/my-wallets",
		//   src: `${process.env.PUBLIC_URL}/${val.theme}/MyWallets.png`,
		// },
		//   {
		//     id: 5,
		//     label: "Create Wallet",
		//     route: "/index/create-wallet",
		//     src: `${process.env.PUBLIC_URL}/${val.theme}/ApiKey.png`,
		//   },
	];

	let filteredOptions = [];
	if (login.data.partnerId === "2" || login.data.partnerId === "105" || login.data.partnerId === "200") {
		filteredOptions = options;
	} else {
		const allowedFlags = getMappedListForAdminRes?.data?.moduleAllocationVO?.masterSubModuleMappingList || [];
		filteredOptions = options.filter(({ flag }) => allowedFlags.includes(flag));
	}
	useEffect(() => {


		dispatch(resetAdminKycMappingList())
		return () => {


			dispatch(resetAdminKycMappingList())
		}
	}, [])

	const filteredOptns = options.filter(({ label }) => {
		// if (
		//   label === "My Cards" && !constants.visibleFlags.includes(isMyCardAllowed)
		// ) {
		//   return label !== "My Cards";
		// }
		// else if (
		//   label === "My Banks" &&  !constants.visibleFlags.includes(isMyBankAllowed)
		// )
		// {
		//   return label !== "My Banks";
		// }
		if (
			label === "My Wallets" &&
			!constants.visibleFlags.includes(isMyWalletAllowed)
		) {
			// return label !== "My Wallets";
		} else return true;
	});
	// .sort((a, b) => {
	//   return a.label > b.label ? 1 : -1;
	// });

	if (!filteredOptns.length) {
		return (
			<Layout>
				<Card className="mk-root">
					<Row className="mk-row m-auto">No My Accounts Available</Row>
				</Card>
			</Layout>
		);
	}

	const handleRoute = (route) => {
		history.push({ pathname: route, state: { from: pathname } });
	};

	return (
		<Layout>
			<Card className="mk-root">
				<Row className="mk-row">
					{filteredOptions.map(({ id, src, label, route }) => (
						<Col key={id} md={4} sm={4} xs={6}>
							<div className="mk-imageRoot" onClick={() => handleRoute(route)}>
								<div className="mk-imageContainer">
									<img className="mk-image" src={src} alt={label} />
								</div>
								<Label for={label} className="fs-14">
									{t(label)}
								</Label>
							</div>
						</Col>
					))}
					{/* {options.map(({ id, src, label, route, flag }) => {
						if (
							getMappedListForAdminRes.success &&
							getMappedListForAdminRes.data.moduleAllocationVO.masterSubModuleMappingList.includes(flag)
						) {
							return (<Col key={id} md={4} sm={4} xs={6}>
								<div className="mk-imageRoot" onClick={() => handleRoute(route)}>
									<div className="mk-imageContainer">
										<img className="mk-image" src={src} alt={label} />
									</div>
									<Label for={label} className="fs-14">
										{t(label)}
									</Label>
								</div>
							</Col>)
						}
					})} */}
				</Row>
			</Card>
		</Layout>
	);
}

export default AdminKycManagement;
